// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"428":"6f5e04e5","625":"7c89af99","787":"3ad83ecd"}[chunkId] + ".chunk.js";
};